import script from "./Alerta.vue?vue&type=script&setup=true&lang=js"
export * from "./Alerta.vue?vue&type=script&setup=true&lang=js"

import "./Alerta.vue?vue&type=style&index=0&id=04785951&lang=css"

const __exports__ = script;

export default __exports__